export const RESPONSIVE_MODE = 800;
